import { render, staticRenderFns } from "./headset.vue?vue&type=template&id=6cd4088e&scoped=true"
import script from "./headset.vue?vue&type=script&lang=js"
export * from "./headset.vue?vue&type=script&lang=js"
import style0 from "./headset.vue?vue&type=style&index=0&id=6cd4088e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd4088e",
  null
  
)

export default component.exports